//

export const LOAD_STUDENTS_INIT = 'LOAD_STUDENTS_INIT';
export const LOAD_STUDENTS_SUCCESS = 'LOAD_STUDENTS_SUCCESS';
export const LOAD_STUDENTS_ERROR = 'LOAD_STUDENTS_ERROR';


export const LOAD_STAFFS_INIT = 'LOAD_STAFFS_INIT';
export const LOAD_STAFFS_SUCCESS = 'LOAD_STAFFS_SUCCESS';
export const LOAD_STAFFS_ERROR = 'LOAD_STAFFS_ERROR';


export const LOAD_PAGE_INIT = 'LOAD_PAGE_INIT';
export const LOAD_PAGE_SUCCESS = 'LOAD_PAGE_SUCCESS';
export const LOAD_PAGE_ERROR = 'LOAD_PAGE_ERROR';

export const LOAD_ARTICLES_INIT = 'LOAD_ARTICLES_INIT';
export const LOAD_ARTICLES_SUCCESS = 'LOAD_ARTICLES_SUCCESS';
export const LOAD_ARTICLES_ERROR = 'LOAD_ARTICLES_ERROR';

export const LOAD_SEMESTERS_INIT = 'LOAD_SEMESTERS_INIT';
export const LOAD_SEMESTERS_SUCCESS = 'LOAD_SEMESTERS_SUCCESS';
export const LOAD_SEMESTERS_ERROR = 'LOAD_SEMESTERS_ERROR';

export const LOAD_SESSION_INIT = 'LOAD_SESSION_INIT';
export const LOAD_SESSION_SUCCESS = 'LOAD_SESSION_SUCCESS';
export const LOAD_SESSION_ERROR = 'LOAD_SESSION_ERROR';

export const LOAD_ARTICLE_INIT = 'LOAD_ARTICLE_INIT';
export const LOAD_ARTICLE_SUCCESS = 'LOAD_ARTICLE_SUCCESS';
export const LOAD_ARTICLE_ERROR = 'LOAD_ARTICLE_ERROR';


export const LOAD_PRODUCTS_INIT = 'LOAD_PRODUCTS_INIT';
export const LOAD_PRODUCTS_SUCCESS = 'LOAD_PRODUCTS_SUCCESS';
export const LOAD_PRODUCTS_ERROR = 'LOAD_PRODUCTS_ERROR';

export const LOAD_MORE_PRODUCTS_INIT = 'LOAD_MORE_PRODUCTS_INIT';
export const LOAD_MORE_PRODUCTS_SUCCESS = 'LOAD_MORE_PRODUCTS_SUCCESS';
export const LOAD_MORE_PRODUCTS_ERROR = 'LOAD_MORE_PRODUCTS_ERROR';

export const SET_FILTER_BY = 'SET_FILTER_BY';
export const SET_SORT_BY = 'SET_SORT_BY';
export const SET_PAGE_TO_LOAD = 'SET_PAGE_TO_LOAD';

export const LIKE_PRODUCT = 'LIKE_PRODUCT';
export const UNLIKE_PRODUCT = 'UNLIKE_PRODUCT';

export const ADD_PRODUCT_TO_CART = 'ADD_PRODUCT_TO_CART';
export const REMOVE_PRODUCT_FROM_CART = 'REMOVE_PRODUCT_FROM_CART';
export const REMOVE_PRODUCTS_FROM_CART = 'REMOVE_PRODUCTS_FROM_CART';

export const LOAD_PRODUCT_INIT = 'LOAD_PRODUCT_INIT';
export const LOAD_PRODUCT_SUCCESS = 'LOAD_PRODUCT_SUCCESS';
export const LOAD_PRODUCT_ERROR = 'LOAD_PRODUCT_ERROR';

export const SHOW_TOAST = 'SHOW_TOAST';
export const HIDE_TOAST = 'HIDE_TOAST';

export const GOOGLE_AUTH_SUCCESS = 'GOOGLE_AUTH_SUCCESS';
export const GET_GOOGLE_USER = 'GET_GOOGLE_USER';
export const LOGOUT_GOOGLE_USER = 'LOGOUT_GOOGLE_USER';

export const REGISTER_LOCAL_USER = 'REGISTER_LOCAL_USER';
export const LOGIN_LOCAL_USER = 'LOGIN_LOCAL_USER';
export const LOGOUT_LOCAL_USER = 'LOGOUT_LOCAL_USER';
export const GET_LOCAL_USER = 'GET_LOCAL_USER';
export const REDIRECT_AFTER_LOGIN = 'REDIRECT_AFTER_LOGIN';
